import React, { useEffect } from "react";
import { Container, Row, Col } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import { EmployeeTable } from '../../account/employee/partials/EmployeeTable';

export default () => {
  useEffect(() => {
    document.title = "Quản lí nhân viên in vé"
  }, []);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Quản lí thiết bị và nhân viên</Breadcrumb.Item>
            <Breadcrumb.Item active>Nhân viên in vé</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Quản lí nhân viên in vé</h4>
          <p className="mb-0">Quản lý nhân viên in vé hệ thống</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col>
            <EmployeeTable />
          </Col>
        </Row>
      </Container>
    </>
  );
};
